export default "__VITE_ASSET__6zSf8mak__"